import { Component, signal, Signal } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MedicalRecordService } from '../../services/medical-record.service';
import { PatientService } from '../../services/patient.service';
import { MedicalRecord } from '../../models/medical-record.model';
import { Patient } from '../../models/patient.model';
import { ButtonComponent, InputComponent } from '../ui';

@Component({
  selector: 'app-medical-records',
  imports: [CommonModule, FormsModule, DatePipe, ButtonComponent, InputComponent],
  templateUrl: './medical-records.component.html',
  styleUrl: './medical-records.component.css'
})
export class MedicalRecordsComponent {
  records!: Signal<MedicalRecord[]>;
  patients!: Signal<Patient[]>;
  showModal = signal(false);
  editingRecord = signal<MedicalRecord | null>(null);
  recordForm = signal<Partial<MedicalRecord>>({});

  constructor(
    private medicalRecordService: MedicalRecordService,
    private patientService: PatientService
  ) {
    this.records = this.medicalRecordService.getRecords();
    this.patients = this.patientService.getPatients();
  }

  openAddModal() {
    this.editingRecord.set(null);
    this.recordForm.set({
      patientId: '',
      patientName: '',
      doctorId: '1',
      doctorName: 'Dr. Sarah Williams',
      date: new Date(),
      visitType: 'Consultation',
      chiefComplaint: '',
      diagnosis: [],
      symptoms: [],
      vitalSigns: {},
      examination: {},
      recommendations: []
    });
    this.showModal.set(true);
  }

  openEditModal(record: MedicalRecord) {
    this.editingRecord.set(record);
    this.recordForm.set({ ...record });
    this.showModal.set(true);
  }

  closeModal() {
    this.showModal.set(false);
    this.editingRecord.set(null);
  }

  onPatientSelect(patientId: string) {
    const patient = this.patients().find((p: Patient) => p.id === patientId);
    if (patient) {
      this.recordForm().patientName = `${patient.firstName} ${patient.lastName}`;
    }
  }

  onDateChange(value: string) {
    this.recordForm().date = new Date(value);
  }

  onDiagnosisChange(value: string) {
    this.recordForm().diagnosis = value.split(',').map(s => s.trim()).filter(s => s.length > 0);
  }

  saveRecord() {
    const form = this.recordForm();
    if (this.editingRecord()) {
      this.medicalRecordService.updateRecord(this.editingRecord()!.id, form);
    } else {
      this.medicalRecordService.addRecord(form as Omit<MedicalRecord, 'id' | 'createdAt' | 'updatedAt'>);
    }
    this.closeModal();
  }

  deleteRecord(id: string) {
    if (confirm('Are you sure you want to delete this medical record?')) {
      this.medicalRecordService.deleteRecord(id);
    }
  }
}

